module.exports = __webpack_public_path__ + "img/square-picture-placeholder.297154f9.png";